import React, { Component } from "react";
import "./Configuration.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  DropdownItem,
  Input,
  Label,
} from "reactstrap";
import InfoIcon from "./InfoIcon";
export default class ConfigModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeConfig: this.props.configItem,
      configItem: {
        listening_ip: "",
        listening_port: "",
        length: "",
        implementation: "",
        eid: "",
      },
      dropdown: false,
      isValid: true,
      validationErrors: [],
      generated: false,
      nodeUUID: "",
    };
  }

  validateInput = () => {
    const listening_ip = this.state.configItem.listening_ip;
    const length = this.state.configItem.length;
    const port =
      this.state.configItem.listening_port === ""
        ? this.state.activeConfig.port
        : this.state.configItem.listening_port;

    let errors = [];

    if (listening_ip === "") {
      errors.push(<li key={"private_ip"}>IP address required</li>);
    } else if (
      !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        listening_ip
      )
    ) {
      errors.push(<li key={"private_ip"}>Entered IP address is not valid</li>);
    }
    if (length === "") {
      errors.push(<li key={"length"}>Contact length required</li>);
    }
    if (!/^[0-9]*$/.test(length)) {
      errors.push(<li key={"length"}>Contact length must be numerical</li>);
    }
    if (port === "") {
      errors.push(<li key={"port"}>Port required</li>);
    }
    if (
      !/^[0-9]*$/.test(port) ||
      parseInt(port) < 0 ||
      parseInt(port) > 65353
    ) {
      errors.push(
        <li key={"port"}>Entered Port is not valid, range is 0-65353</li>
      );
    }

    if (errors.length > 0) {
      this.setState({ isValid: false, validationErrors: errors });
      return false;
    }
    this.setState({ isValid: true, validationErrors: [] });
    return true;
  };

  handleChange = async (e) => {
    let { name, value } = e.target;
    const configItem = { ...this.state.configItem, [name]: value };
    await this.setState({ configItem });
    if (this.state.generated) {
      if (!this.validateInput()) {
        this.setState({ generated: false });
      }
    }
  };

  renderHosts = () => {
    const hosts = this.props.nodeList;
    const user = this.props.user;

    return hosts.map((item) =>
      item.owner === user ? (
        <DropdownItem
          className="dropdown_item"
          key={item.eid}
          onClick={() => this.setLastClicked(item)}
        >
          Node {item.eid}
        </DropdownItem>
      ) : null
    );
  };

  dropdownToggle = () => {
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const { configToggle, getErrors, config, download } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={configToggle}>
        <ModalHeader>
          {" Node " +
            this.state.activeConfig.eid +
            " - Configuration Generation "}
          <InfoIcon
            infoText={
              "Fill in the form for a url that will always generate the latest ION configuration file with the provided information"
            }
            position={"right"}
          />
          <button className="exit_close_button" onClick={configToggle}>
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          {this.state.isValid ? (
            getErrors()
          ) : (
            <div className="dropdown_error">
              <div className="error_area">
                <ul style={{ color: "red" }}>{this.state.validationErrors}</ul>
              </div>
            </div>
          )}
          <Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Label for="listening_ip">Private (Listening) IP Address</Label>
              <InfoIcon
                infoText={
                  "Address the node will listen on. (If natting, usually the node's private IP)."
                }
                position={"right"}
              />
              <Input
                type="text"
                name="listening_ip"
                value={this.state.configItem.listening_ip}
                onChange={this.handleChange}
                placeholder="Enter Node Private IP"
                maxLength="15"
              />
            </FormGroup>
            <FormGroup className="fg">
              <Label for="listening_port">
                Listening Port - (Default to{" "}
                <b>{this.state.activeConfig.port}</b> if blank)
              </Label>
              <InfoIcon
                infoText={"Port the node will listen on."}
                position={"right"}
              />
              <Input
                type="text"
                name="listening_port"
                value={this.state.configItem.listening_port}
                onChange={this.handleChange}
                placeholder={this.state.activeConfig.port}
                maxLength="15"
              />
            </FormGroup>
            <FormGroup className="fg">
              <Label for="length">Contact Length</Label>
              <InfoIcon
                infoText={
                  "In seconds, how long the contacts will last for (i.e. '3600' for 1 hour)."
                }
                position={"right"}
              />
              <Input
                type="text"
                name="length"
                value={this.state.configItem.length}
                onChange={this.handleChange}
                placeholder="Enter Length of Contacts"
                maxLength="40"
              />
            </FormGroup>
          </Form>
          The generated configuration assumes a <b>mesh network.</b>
          <br />
          (All nodes are linked together for the specified contact length)
        </ModalBody>
        <ModalFooter>
          <>
            {this.state.generated ? (
              <>
                Download files:
                <button
                  className="download_button"
                  onClick={() => {
                    download(
                      `${this.props.baseUrl}/api/dynamic-config?node=${
                        this.state.nodeUUID
                      }&listeningip=${
                        this.state.configItem.listening_ip
                      }&listeningport=${
                        this.state.configItem.listening_port === ""
                          ? this.state.activeConfig.port
                          : this.state.configItem.listening_port
                      }&length=${this.state.configItem.length}`
                    );
                  }}
                >
                  {this.state.activeConfig.implementation === "HDTN" ? <>HDTN ONE</> : <> ION RC</>}
                  
                </button>
                {this.state.activeConfig.implementation === "HDTN" ? (
                  <>
                    <button
                      className="download_button"
                      onClick={() => {
                        download(
                          `${
                            this.props.baseUrl
                          }/api/dynamic-scheduler?node=${
                            this.state.nodeUUID
                          }&listeningip=${
                            this.state.configItem.listening_ip
                          }&listeningport=${
                            this.state.configItem.listening_port === ""
                              ? this.state.activeConfig.port
                              : this.state.configItem.listening_port
                          }&length=${this.state.configItem.length}`
                        );
                      }}
                    >
                      Scheduler
                    </button>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : null}
            <button
              className="gen_button"
              disabled={config !== ""}
              onClick={() => {
                if (this.validateInput()) {
                  this.setState({ nodeUUID: this.props.configItem.uuid });
                  this.setState({ generated: true });
                }
              }}
            >
              Generate
            </button>
            {this.state.generated ? (
              <div className="generated_area">
                <h4 style={{ color: "#60f056" }}>Success</h4>
                {this.state.activeConfig.implementation === "ION" ? (
                  <>
                    <p>ION configuration download:</p>
                    <code style={{ color: "white" }}>
                      {`wget -O ion_host_${this.state.activeConfig.eid}.rc '${
                        this.props.baseUrl
                      }/api/dynamic-config?node=${
                        this.state.nodeUUID
                      }&listeningip=${
                        this.state.configItem.listening_ip
                      }&listeningport=${
                        this.state.configItem.listening_port === ""
                          ? this.state.activeConfig.port
                          : this.state.configItem.listening_port
                      }&length=${this.state.configItem.length}'`}
                    </code>
                  </>
                ) : (
                  <></>
                )}
                {this.state.activeConfig.implementation === "HDTN" ? (
                  <>
                    <p>HDTN ONE configuration download:</p>
                    <code style={{ color: "white" }}>
                      {`wget -O hdtn_one_${
                        this.state.activeConfig.eid
                      }_host.json '${
                        this.props.baseUrl
                      }/api/dynamic-config?node=${
                        this.state.nodeUUID
                      }&listeningip=${
                        this.state.configItem.listening_ip
                      }&listeningport=${
                        this.state.configItem.listening_port === ""
                          ? this.state.activeConfig.port
                          : this.state.configItem.listening_port
                      }&length=${this.state.configItem.length}'`}
                    </code>
                    <p>Scheduler file download:</p>
                    <code style={{ color: "white" }}>
                      {`wget -O hdtn_scheduler_${
                        this.state.activeConfig.eid
                      }_host.json '${
                        this.props.baseUrl
                      }/api/dynamic-scheduler?node=${
                        this.state.nodeUUID
                      }&listeningip=${
                        this.state.configItem.listening_ip
                      }&listeningport=${
                        this.state.configItem.listening_port === ""
                          ? this.state.activeConfig.port
                          : this.state.configItem.listening_port
                      }&length=${this.state.configItem.length}'`}
                    </code>
                  </>
                ) : (
                  <></>
                )}
              </div>
            ) : null}
          </>
        </ModalFooter>
      </Modal>
    );
  }
}
